export const SOCIAL_MEDIA_URLS = {
    facebook: "https://www.facebook.com/OpenSourceUoM/",
    instagram: "https://www.instagram.com/opensourceuom/",
    youtube:
        "https://www.youtube.com/channel/UC98Ggzq6dl_nn5Y0BHb6SLA?sub_confirmation=1",
    twitter: "https://twitter.com/opensource_uom",
    LinkedIn: "https://www.linkedin.com/company/80766091/",
    gitlab: "https://gitlab.com/opensourceuom",
    discord: "https://discord.com/invite/XtxtM3ZHUm",
};